/* tslint:disable */
/* eslint-disable */
/**
 * MAPIIO API
 * API mapové aplikace Mapiio pro klientskou JavaScriptovou / React část.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



    /**
 * 
 * @export
 * @enum {string}
 */

export const EnumTypVysledekDtm = {
    /**
    * Podání editace zamítnuto
    */
    PODANI_ZAMITNUTO: 'PODANI_ZAMITNUTO',
    /**
    * Editace nezplatněna
    */
    EDITACE_NEZPLATNENA: 'EDITACE_NEZPLATNENA',
    /**
    * Editace zplatněna
    */
    EDITACE_ZPLATNENA: 'EDITACE_ZPLATNENA'
} as const;

export type EnumTypVysledekDtm = typeof EnumTypVysledekDtm[keyof typeof EnumTypVysledekDtm];



